import styled from "styled-components";
import { IMG_SYSTEM_MAINTAIN } from "@assets";
import { Button as AntButton } from "antd";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Image = styled.img.attrs({
  alt: "SystemMaintain",
  src: IMG_SYSTEM_MAINTAIN,
})`
  object-fit: cover;
  aspect-ratio: 1;
  width: 160px;
  height: 160px;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: ${(props) => props.theme.primarySolid};
  padding-top: 18px;
  text-align: center;
`;

export const Description = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: ${(props) => props.theme.textColor};
  padding: 10px 20px 30px 20px;
  text-align: center;
`;

export const Button = styled(AntButton)`
  background: ${(props) => props.theme.primaryGradient};
  width: 135px;
  height: 56px;
`;
